import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const AreaBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const emptyRecord = {
    area: null
  }
  const [data, setData] = useState<object|null>(_.get(props, "rowData.areadetail"));

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'areadetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Area</label>
          <NumberInput 
            className="automated billion-input" 
            data={data} 
            attrs={attrs} 
            field="area" 
            min={0} 
            max={1000000000} 
            persist={updateData} 
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default AreaBasic
